export default "__VITE_PUBLIC_ASSET__304c5e89__"